<style scoped="scoped" lang="scss">
._form /deep/ .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  // height: 40px;
  line-height: 40px;
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100px;
}

._formItem /deep/ .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  // height: 40px;
  line-height: 40px;
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 80px;
}

._form /deep/ .el-input__icon {
  content: '';
  height: 100%;
  width: 0;
  display: inline-block;
  vertical-align: middle;
  margin-left: -220px;
}

._form /deep/ .el-select {
  min-width: 80px;

  .el-select-dropdown {
    .el-scrollbar {
      .el-select-dropdown__wrap {
        .el-scrollbar__view {
          .el-select-dropdown__item:hover {}
        }
      }
    }
  }
}
</style>
<style>
/* 隐藏全选按钮 */
.role-section .el-table__header-wrapper .el-checkbox {
  display: none;
}

/* 调拨 */
.allocation-form {
  margin-top: 15px;
}

/* 组织树状图 */
.org-input {
  width: 200px;
  margin-left: 10px;
}

/* 已选中设备 */
.eq-select {
  /* margin-top: 15px; */
}

/* 已选中标签 */
.eq-select-tag {
  margin-left: 8px;
}

/* 分页 */
.pagination {
  float: right;
  margin-top: 10px;
}
</style>
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/equipment/standing_book/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shebeimingcheng')">
            <el-input v-model="yt.conditions.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeiSN')">
            <el-input v-model="yt.conditions.sn"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeixinghao')">
            <el-input v-model="yt.conditions.modelCode"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeileixing')">
            <yi_dictionary_select :type="'EQUIPMENT_TYPES'" :ids.sync="yt.conditions.typeId"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('suoshuzuzhi')">
            <yi_data_select :type="'organization'" :idsPath.sync="yt.conditions.orgIds" :ids.sync="yt.conditions.selecteOrgId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('guishuzhujiSN')">
            <el-input v-model="yt.conditions.belongSn"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chuchangriqi')">
            <yi_time_input :format="'yyyy-MM-dd'" type="daterange" :start.sync="yt.conditions.leaveFactoryDateStart" :end.sync="yt.conditions.leaveFactoryDateEnd"> </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('fenzumingcheng')">
            <yi_dictionary_select :type="'EQUIPMNET_GROUP_NAME_TYPE'" :ids.sync="yt.conditions.groupName"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ orderBy: 'sort' })">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" v-if="utils.checkPower('web_base_equipment_equipmentOrgUpdate')" type="primary" @click="yt.showEditDialog('shebeidiaobo', {}, '80%')">
          {{ $t('shebeidiaobo') }}
        </el-button>
        <el-button size="mini" v-if="utils.checkPower('web_base_equipment_setBatchEquipmentBoard')" @click="yt.showEditDialog('piliangshezhikanbanpeizhidian', {}, '650px')" plain>
          {{ $t('piliangshezhikanbanpeizhidian') }}
        </el-button>
        <el-button size="mini" v-if="utils.checkPower('web_base_equipment_snQrCode')" @click="yt.showEditDialog('dayinshebeisnerweima', {}, '500px')">
          {{ $t('dayinshebeisnerweima') }}
        </el-button>
        <el-button size="mini" @click="yt.showEditDialog('dayinshebeibiaoqian', {}, '500px')">
          {{ $t('dayinshebeibiaoqian') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" :loading="yt.editObj.loading" icon="yicon yicon-export" :title="$t('daochu')" @click="exportExcel()"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" v-if="utils.checkPower('web_base_equipment_update')" @click="yt.showEditDialog('bianji', scope.row, null, beforeShowDialog)">{{ $t('bianji') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" v-if="utils.checkPower('web_base_equipment_getEquipmentBoard')" @click="yt.showEditDialog('shezhikanbanpeizhidian', scope.row, '623px')">
              {{ $t('shezhikanbanpeizhidian') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" v-if="utils.checkPower('web_base_equipment_process_stability_params')" @click="yt.showEditDialog('gongyigongchafanweishezhi', scope.row, '623px')">
              {{ $t('gongyigongchafanweishezhi') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body" @close="dialogClose">
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <div class="dialog-scroller-form">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('shebeiSN')" class="noborder">
              <el-input v-model="yt.editObj.sn" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('shebeixinghao')" required>
              <!-- <yi_cross_select :component="'admin_equipment_series_series_model'" :max="1"
                :ids.sync="yt.editObj.modelId"></yi_cross_select> -->
              <yi_cross_select :component="'admin_equipment_series_series_model'" :fixShowColumns="modelColumns" :max="1" :ids.sync="yt.editObj.modelId" @getItems="setTypeId"> </yi_cross_select>
            </el-form-item>
            <el-form-item :label="$t('shebeimingcheng')">
              <el-input v-model="yt.editObj.name"></el-input>
            </el-form-item>
            <el-form-item :label="$t('suoshuzuzhi')">
              <yi_data_select :type="'organization'" :ids.sync="yt.editObj.orgId" :key="refreshOneKey"> </yi_data_select>
            </el-form-item>
            <el-form-item :label="$t('chuchangriqi')">
              <yi_time_input :format="'yyyy-MM-dd'" type="date" :time.sync="yt.editObj.leaveFactoryDate"> </yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('baofeiriqi')">
              <yi_time_input :format="'yyyy-MM-dd'" type="date" :time.sync="yt.editObj.scrapData"> </yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('dunwei')">
              <el-input type="text" @input="yt.editObj.tonnage = String(yt.editObj.tonnage).replace(/[^\d]/g, '')" v-model="yt.editObj.tonnage"></el-input>
            </el-form-item>
            <el-form-item :label="$t('yibiaohao')">
              <el-input type="text" v-model="yt.editObj.meterNo" :maxlength="100"></el-input>
            </el-form-item>
            <el-form-item :label="$t('yibiaomingcheng')">
              <el-input type="text" v-model="yt.editObj.meterName" :maxlength="100"></el-input>
            </el-form-item>
            <el-form-item :label="$t('fenzumingcheng')">
              <yi_dictionary_select :type="'EQUIPMNET_GROUP_NAME_TYPE'" :ids.sync="yt.editObj.groupName"> </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('paixu')">
              <el-input-number :min="1" v-model="yt.editObj.sort"></el-input-number>
            </el-form-item>
            <el-form-item :label="$t('guishuzhujiSN')">
              <el-input v-model="yt.editObj.belongSn"></el-input>
            </el-form-item>
            <el-form-item :label="$t('plckongzhiqixinghao')">
              <yi_dictionary_select :type="'YSTJ'" :ids.sync="yt.editObj.plcControllerModel"> </yi_dictionary_select>
            </el-form-item>
            <div class="_form">
              <el-form-item :label="$t('jingdu')" style="display: flex;flex-wrap: nowrap;white-space: nowrap;margin-left: 106px">
                <div style="display: flex;flex-wrap: nowrap">
                  <div style="display: flex;flex-wrap: nowrap">
                    <el-col :span="3">
                      <el-select v-model="yt.editObj.longitude" :popper-class="'custom-dropdown'" :popper-append-to-body="false">
                        <el-option :label="$t('dongjing')" :value="$t('dongjing')"></el-option>
                        <el-option :label="$t('xijing')" :value="$t('xijing')"></el-option>
                      </el-select>
                    </el-col>
                    <div class="_formItem" style="display: flex;flex-wrap: nowrap">
                      <el-input style="margin-left: 63px" v-model="yt.editObj.longitudeNum" oninput="value=value.replace(/[^-0-9.]/g , '')"></el-input>
                      <div style="margin-left: -110px">{{ $t('du') }}</div>
                    </div>
                  </div>
                  <div class="_formItem" style="display: flex;flex-wrap: nowrap">
                    <el-input style="margin-left: -145px" v-model="yt.editObj.longitudeDivide" oninput="value=value.replace(/[^-0-9.]/g , '')"></el-input>
                    <div style="margin-left: -110px">{{ $t('fen') }}</div>
                  </div>
                </div>
              </el-form-item>
              <el-form-item :label="$t('weidu1')" style="display: flex;flex-wrap: nowrap;white-space: nowrap;margin-left: 106px">
                <div style="display: flex;flex-wrap: nowrap">
                  <div style="display: flex;flex-wrap: nowrap">
                    <el-col :span="3">
                      <el-select v-model="yt.editObj.latitude" :popper-class="'custom-dropdown'" :popper-append-to-body="false">
                        <el-option :label="$t('beiwei')" :value="$t('beiwei')"></el-option>
                        <el-option :label="$t('nanwei')" :value="$t('nanwei')"></el-option>
                      </el-select>
                    </el-col>

                    <div class="_formItem" style="display: flex;flex-wrap: nowrap">
                      <el-input style="margin-left: 63px" v-model="yt.editObj.latitudeNum" oninput="value=value.replace(/[^-0-9.]/g , '')"></el-input>
                      <div style="margin-left: -110px">{{ $t('du') }}</div>
                    </div>
                  </div>
                  <div class="_formItem" style="display: flex;flex-wrap: nowrap">
                    <el-input style="margin-left: -145px" v-model="yt.editObj.latitudeDivide" oninput="value=value.replace(/[^-0-9.]/g , '')"></el-input>
                    <div style="margin-left: -110px">{{ $t('fen') }}</div>
                  </div>
                </div>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <template slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/equipment/standing_book/update', beforeAdd)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </template>
      </template>
      <!-- 设置配置点看板 -->
      <template v-if="yt.editObj.action == 'shezhikanbanpeizhidian'">
        <div style="height: 320px;">
          <el-transfer :titles="[$t('yincanglie'), $t('xianshilie')]" v-model="settingPoint" target-order="push" :data="settingData" :props="{ key: 'code', label: 'desc' }">
            <span slot-scope="{ option }">
              <span>{{ option.desc }}</span>
              <span v-if="settingPoint.length > 0 && settingPoint.includes(option.code)">
                <em v-if="settingPoint[0] !== option.code" class="el-icon-top" @click.stop.prevent="changePoint('up', option.code)"></em>
                <em v-if="settingPoint[settingPoint.length - 1] !== option.code" class="el-icon-bottom" @click.stop.prevent="changePoint('down', option.code)"></em>
              </span>
            </span>
          </el-transfer>
        </div>
        <template slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="setEquipmentBoard" type="primary">{{ $t('baocun') }} </el-button>
        </template>
      </template>

      <!-- 设置配置点看板 -->
      <template v-if="yt.editObj.action == 'gongyigongchafanweishezhi'">
        <div class="dialog-scroller">
          <process_stability_params :equipment="yt.editObj"></process_stability_params>
        </div>
      </template>

      <!-- 批量设置看板配置点 -->
      <template v-if="yt.editObj.action == 'piliangshezhikanbanpeizhidian'">
        <div class="dialog-scroller">
          <el-transfer :titles="[$t('shebeiliebiao'), $t('xuanzhongshebei')]" v-model="selectEquipment" :data="equipmentList" :props="{
            key: 'id',
            label: 'name'
          }">
          </el-transfer>
          <div style="margin-top: 12px;">
            <el-transfer :titles="[$t('yincangneirong'), $t('xianshineirong')]" v-model="settingBatchPoint" target-order="push" @right-check-change="choose" :data="settingBatchData" :props="{
              key: 'code',
              label: 'desc'
            }">
              <span slot-scope="{ option }">
                <span>{{ option.desc }}</span>
                <span v-if="settingBatchPoint.length > 0 && settingBatchPoint.includes(option.code)">
                  <em v-if="settingBatchPoint[0] !== option.code" class="el-icon-top" @click.stop.prevent="changeSort('up', option.code)"></em>
                  <em v-if="settingBatchPoint[settingBatchPoint.length - 1] !== option.code" class="el-icon-bottom" @click.stop.prevent="changeSort('down', option.code)"></em>
                </span>
              </span>
            </el-transfer>
          </div>
        </div>
        <template slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="setBatchEquipmentBoard" type="primary">{{ $t('baocun') }} </el-button>
        </template>
      </template>
      <template v-if="yt.editObj.action == 'jimopei'">
        <div class="dialog-scroller">
          <equipment_model></equipment_model>
        </div>
        <template slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.req('POST', '/web/basic/mould/update')" type="primary">{{ $t('queren') }} </el-button>
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
        </template>
      </template>
      <!-- 设备调拨 -->
      <template v-if="yt.editObj.action == 'shebeidiaobo'">
        <div class="dialog-scroller" style="display: flex;flex-direction: column;">
          <div style="flex-shrink: 0;">
            <el-form :inline="true" ref="form" size="mini">
              <el-form-item :label="$t('mubiaozuzhi')" required>
                <yi_data_select :type="'organization'" :idsPath.sync="orgId" :ids.sync="simpleOrgId" :key="refreshOneKey"> </yi_data_select>
              </el-form-item>
            </el-form>
            <div class="eq-select" style="">
              <el-tag v-for="(item, index) in multipleSelection" @click="handleSelectionChange" :key="index" closable size="mini" @close="closeTag(item.id)" class="eq-select-tag">
                {{ item.name }}
              </el-tag>
            </div>
          </div>

          <div style="flex:1">
            <yi_cross_select :component="'web_base_equipment_equipment_standing'" :key="id" :min="1" :ids.sync="yt.editObj.equipmentIds" multiple :isInput="false"> </yi_cross_select>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="submitAllocation" type="primary">{{ $t('querendiaobo') }} </el-button>
        </div>
      </template>
      <!-- 打印设备SN二维码 -->
      <template v-if="yt.editObj.action == 'dayinshebeisnerweima'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <div style="display: flex;">
            <el-form-item :label="$t('dayinshebei')" class="noborder" style="padding: 6px 0;">
              <el-select filterable :clearable="true" :multiple-limit="999" v-model="printSN" :multiple="true" collapse-tags :placeholder="$t('qingxuanze')" :reserve-keyword="true">
                <el-option v-for="item in items" :key="item.sn" :label="item.name + '(' + item.sn + ')'" :value="item.sn"></el-option>
              </el-select>
            </el-form-item>
            <div style="width: 100px;">
              <el-button type="text" @click="chooseAll">{{ $t('quanxuan') }}</el-button>
            </div>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false; isShowPrint = false;">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="preview" type="primary">
            {{ $t('yulan') }}
          </el-button>
        </div>
      </template>
      <!-- 打印设备标签 -->
      <template v-if="yt.editObj.action == 'dayinshebeibiaoqian'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('dayinmobanmingcheng')" required>
            <el-select v-model="batchPrintInfo.printTemplateId" :placeholder="$t('qingxuanze')" clearable>
              <el-option v-for="item in printTemplates" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
          <div style="display: flex;">
            <el-form-item :label="$t('dayinshebei')" required class="noborder" style="padding: 6px 0;">
              <el-select filterable :clearable="true" :multiple-limit="999" v-model="batchPrintInfo.equipmentIds" :multiple="true" collapse-tags :placeholder="$t('qingxuanze')" :reserve-keyword="true">
                <el-option v-for="item in items" :key="item.sn" :label="item.name + '(' + item.sn + ')'" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <div style="width: 100px;">
              <el-button type="text" @click="printChooseAll">{{ $t('quanxuan') }}</el-button>
            </div>
          </div>
          <el-form-item :label="$t('dayinzhangshu')" required>
            <el-input-number v-model="batchPrintInfo.num" :min="1"></el-input-number>
            <div style="float: right;padding-left: 8px;font-size: 18px;cursor: pointer;">
              <el-tooltip class="item" effect="dark" content="每台设备需要打印的标签张数" placement="right-start">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </div>
          </el-form-item>
          <el-form-item :label="$t('riqi')" required>
            <el-date-picker v-model="batchPrintInfo.printDate" type="date" value-format="yyyy-MM-dd" :placeholder="$t('qingxuanze')"> </el-date-picker>
          </el-form-item>
          <div style="display: flex;justify-content: center;">
            <yi_print_preview v-if="batchPrintInfo.preview && batchPrintInfo.printTemplateId && batchPrintInfo.equipmentIds.length > 0" :isPreview="true" :printTemplateId.sync="batchPrintInfo.printTemplateId" :scale="4" :printDatas="parseBatchPrintData()" ref="batchPrintReview"></yi_print_preview>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <div>
            <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
            <el-button size="mini" type="info" @click="batchPrintInfo.preview = !batchPrintInfo.preview">{{ $t('yulan') }}</el-button>
            <el-button size="mini" @click="batchPrint()" type="primary">{{ $t('dayin') }}</el-button>
          </div>
        </span>
      </template>
    </el-dialog>

    <!-- 目标组织 -->
    <el-dialog :title="$t('mubiaozuzhi')" :visible.sync="orgDialog" width="80%">
      <div style="font-size: 18px">{{ this.$t('yixuanzuzhi') + ': ' + selectOrg.text }}</div>
      <div v-loading="g_loading" style="margin-top:30px;width: calc(100% - 10px);height:500px;">
        <SeeksRelationGraph ref="seeksRelationGraph" :options="graphOptions" :on-node-click="onNodeClick" />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="cancelNode()">{{ $t('quxiao') }}</el-button>
        <el-button :loading="store.state.global_loading" size="mini" @click="submitOrg" type="primary">
          {{ $t('baocun') }}
        </el-button>
      </div>
    </el-dialog>
    <!-- 设备SN二维码预览 -->
    <el-dialog :title="$t('dayinyulan')" :visible.sync="isShowPrint" append-to-body="append-to-body" width="450px">
      <template v-if="isShowPrint">
        <div class="dialog-scroller-form" style="margin-top: 20px;height: 500px;">
          <div :id="'printContent_' + index" v-for="(item, index) in printSN" :key="index" style="font-size: 10px;padding:4px;box-sizing: border-box;border: 1px solid transparent;line-height: 18px;" :style="{ width: getDpi(100) + 'px', height: getDpi(80) + 'px', 'margin-top': index == 0 ? '0px' : '-1px' }">
            <div style="text-align: center;justify-content: center;align-items: center;">
              <vue-qr :text="item" :margin="10" :size="200"></vue-qr>
              <div style="font-size: 30px;color: black;">{{(items.find(i => i.sn == item)).name}}</div>
            </div>
          </div>
        </div>
        <div style="text-align: center;padding: 20px 0;">
          <el-button :loading="printLoading" @click="isShowPrint = false" style="width: 130px;">{{ $t('quxiao') }}</el-button>
          <el-button :loading="printLoading" type="primary" @click="print" style="width: 130px;">{{ $t('dayin') }}</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import equipment_model from '@@/pages/web/base/equipment/equipment_model';
// import equipment_standing from '@@/pages/web/base/equipment/equipment_standing'
import SeeksRelationGraph from 'relation-graph';
import process_stability_params from '@@/pages/web/base/equipment/process_stability_params';
import html2canvas from 'html2canvas';
import VueQr from 'vue-qr';
import jsPDF from 'jspdf';
import dayjs from 'dayjs';

export default {
  name: 'web_base_equipment_list',
  components: {
    equipment_model,
    // equipment_standing,
    SeeksRelationGraph,
    process_stability_params,
    VueQr
  },
  data() {
    return {
      printTemplates: [],
      batchPrintInfo: {
        printTemplateId: null,
        equipmentIds: [],
        preview: false,
        num: 1,
        printDate: dayjs().format('YYYY-MM-DD')
      },
      selfIndex: '',
      simpleOrgId: '',
      refreshOneKey: 0,
      refreshTwoKey: 0,
      equipmentIds: '',
      indexKey: null, // 高亮显示
      // organizationList: [],
      modelColumns: [
        {
          label: 'shebeixinghao',
          prop: 'code',
          sort: 'string',
          width: 150
        },
        {
          label: 'shebeileixing',
          prop: 'seriesTypeId',
          type: 'dictionary',
          key: 'EQUIPMENT_TYPES',
          width: 150
        },
        {
          label: 'shebeixiliemingcheng',
          prop: 'seriesName',
          width: 130
        },
        {
          label: 'zhizaoshang',
          prop: 'manufacturer'
        }
      ],
      columns: [
        {
          label: 'shebeimingcheng',
          prop: 'name',
          sort: 'string',
          width: 130
        },
        {
          label: 'shebeiSN',
          prop: 'sn',
          sort: 'string',
          width: 130
        },
        {
          label: 'shebeixinghao',
          prop: 'model.code',
          sort: 'string'
        },
        {
          label: 'shebeileixing',
          prop: 'typeId',
          type: 'dictionary',
          key: 'EQUIPMENT_TYPES',
          width: 130
        },
        {
          label: 'suoshuzuzhi',
          prop: 'org.name',
          width: 180
        },
        {
          label: 'chuchangriqi',
          prop: 'leaveFactoryDate',
          type: 'time',
          format: 'YYYY-MM-DD'
        },
        {
          label: 'baofeiriqi',
          prop: 'scrapData',
          type: 'time',
          format: 'YYYY-MM-DD'
        },
        {
          label: 'dunwei',
          prop: 'tonnage',
          sort: 'number'
        },
        {
          label: 'yibiaohao',
          prop: 'meterNo'
        },
        {
          label: 'yibiaomingcheng',
          prop: 'meterName'
        },
        {
          label: 'fenzumingcheng',
          prop: 'groupName',
          type: 'dictionary',
          key: 'EQUIPMNET_GROUP_NAME_TYPE'
        },
        {
          label: 'paixu',
          prop: 'sort'
        },
        {
          label: 'jingdu',
          prop: 'longitude',
          width: 180
        },
        {
          label: 'weidu1',
          prop: 'latitude',
          width: 180
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 300,
          fixed: 'right'
        }
      ],
      // 设备调拨相关参数
      equipmentDialog: false,
      queryParam: {},
      org: '',
      total: 0,
      pageNum: 0,
      pageSize: 10,
      tableData: [],
      multipleSelection: [],
      orgDialog: false,
      orgId: '',
      selectOrg: {
        text: ''
      },
      g_loading: true,
      demoname: '---',
      graphOptions: {
        layouts: [
          {
            label: '中心',
            layoutName: 'tree',
            layoutClassName: 'seeks-layout-tree',
            defaultJunctionPoint: 'border',
            defaultNodeShape: 0,
            defaultLineShape: 1,
            centerOffset_y: 0
          }
        ],
        defaultExpandHolderPosition: 'bottom', // 默认的节点展开/关闭按钮位置（left/top/right/bottom）
        defaultLineShape: 4, // 默认的线条样式（1:直线/2:样式2/3:样式3/4:折线/5:样式5/6:样式6）
        defaultJunctionPoint: 'tb', // 默认的连线与节点接触的方式（border:边缘/ltrb:上下左右/tb:上下/lr:左右）当布局为树状布局时应使用tb或者lr，这样才会好看
        defaultNodeShape: 1, // 默认的节点形状，0:圆形；1:矩形
        defaultNodeBorderWidth: 1, // 默认的节点边框粗细（像素）
        defaultFocusRootNode: false, // 默认根节点为选中样式
        defaultNodeColor: '#fff',
        defaultNodeFontColor: '#000',
        defaultNodeBorderColor: '#000'
      },
      chooseSelf: '',
      settingPoint: [],
      settingData: [],
      settingBatchPoint: [],
      settingBatchPoints: [],
      settingBatchData: [],
      specifiedElem: [],
      equipmentList: [],
      selectEquipment: [],
      items: [],
      printSN: [],
      isShowPrint: false,
      blobs: [],
      printLoading: false,
    };
  },
  provide() {
    return {
      Equipment: this
    };
  },
  watch: {
    simpleOrgId: {
      handler(n) {
        console.log('ck', n);
      },
      immediate: false
    },
    equipmentDialog: {
      handler(n, o) {
        if (n) {
          this.pageNum = 1;
          this.queryParam = {};
          this.getStandingBook();
        } else {
          this.pageNum = 1;
          this.queryParam = {};
          this.tableData = [];
          this.orgId = '';
          this.selectOrg = {
            text: ''
          };
          this.multipleSelection = [];
        }
      },
      immediate: false
    },
    orgDialog: {
      handler(n, o) {
        this.demoname = this.$route.params.demoname;
        this.setGraphData();
      },
      immediate: false
    },
    'yt.editObj.action'(value) {
      if (value === 'shezhikanbanpeizhidian') {
        this.getEquipmentBoard();
      }
      if (value === 'piliangshezhikanbanpeizhidian') {
        this.getBatchEquipmentBoard();
        this.getEquipmentList();
      }
    },
    'store.state.eqs'() {
      this.items = this.store.state.eqs.map(item => {
        if (item.name == null || item.name == "") {
          item.name = '';
        }
        return item;
      });
    },
  },
  created() {
    this.listPrintTemplates();
    setTimeout(() => {
      this.yt.conditions = {
        orderBy: 'sort'
      };
      this.yt.SELECT_URL = '/web/equipment/standing_book/getEquipmentByIds';
      this.yt.SELECT_RESULT_KEY = 'data';
      this.yt.SELECT_ID = 'id';
      this.yt.SELECT_TITLE = 'name';
      this.yt.get(1);
      // this.getOrganizationList()
    }, 300);
    setTimeout(() => {
      this.$set(this, 'items', this.$store.state.eqs.map(item => {
        if (item.name == null || item.name == "") {
          item.name = '';
        }
        return item;
      }))
    }, 1000);
  },
  methods: {
    batchPrint() {
      if (!this.batchPrintInfo.preview) {
        this.$message.warning(this.$t('qingxianyulan'));
        return;
      }
      if (!this.batchPrintInfo.printTemplateId || !this.batchPrintInfo.equipmentIds || this.batchPrintInfo.equipmentIds.length === 0) {
        this.$message.warning(this.$t('shujubitian'));
        return;
      }
      this.$refs.batchPrintReview.toPrint(true);
    },
    parseBatchPrintData() {
      console.log('items', this.items);
      const arr = this.items.filter(item => {
        return this.batchPrintInfo.equipmentIds.includes(item.id);
      });
      const data = [];
      for (let i = 0; i < arr.length; i++) {
        const e = arr[i];
        const date = e.leaveFactoryDate;
        const d = date ? dayjs(date).format('YYYY-MM-DD') : '';
        for (let j = 0; j < this.batchPrintInfo.num; j++) {
          data.push({
            equipmentName: e.name,
            equipmentSn: e.sn,
            modelCode: e.modelCode,
            leaveFactoryDate: d,
            printDate: this.batchPrintInfo.printDate,
          });
        }
      }
      return data;
    },
    // 获取打印模板管理-模具标签的名称列表
    listPrintTemplates() {
      this.http
        .get('/web/print/template/page?pageNum=1&pageSize=999&type=7')
        .then(res => {
          if (res.data && res.data.rows && res.data.rows.length > 0) {
            this.printTemplates = res.data.rows || [];
            // 默认选最近新建的
            this.batchPrintInfo.printTemplateId = this.printTemplates[this.printTemplates.length - 1].id;
          }
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        })
        .finally(() => { });
    },
    // 弹窗关闭调用
    dialogClose() {
      // 清空 打印设备SN二维码 选择缓存
      if (this.yt.editObj.action == 'dayinshebeisnerweima') {
        this.printSN = [];
      }
      this.batchPrintInfo = {
        printTemplateId: null,
        equipmentIds: [],
        preview: false,
        num: 1,
        printDate: dayjs().format('YYYY-MM-DD')
      };
    },
    // 设置设备类型ID
    setTypeId(row) {
      this.yt.editObj.typeId = row.seriesTypeId;
    },
    beforeAdd(params, url) {
      params.longitude = (params.longitude === undefined ? '' : params.longitude) + (params.longitudeNum === undefined ? '' : params.longitudeNum) + (params.longitudeNum === undefined ? '' : this.$t('du')) + (params.longitudeDivide === undefined ? '' : params.longitudeDivide) + (params.longitudeDivide === undefined ? '' : this.$t('fen'));
      params.latitude = (params.latitude === undefined ? '' : params.latitude) + (params.latitudeNum === undefined ? '' : params.latitudeNum) + (params.latitudeNum === undefined ? '' : this.$t('du')) + (params.latitudeDivide === undefined ? '' : params.latitudeDivide) + (params.latitudeDivide === undefined ? '' : this.$t('fen'));
      return params;
    },
    beforeShowDialog() {
      if (this.yt.editObj.latitude || this.yt.editObj.longitude) {
        if (this.yt.editObj.longitude !== '') {
          let a = this.yt.editObj.longitude;
          // 使用正则表达式匹配并截取字符串
          // const regex = /(\D+)?(\d+)?度?(\d+)?分?/;
          // const matches = a.match(regex);
          const b = a.match(/([\u4e00-\u9fa5]+)/)[0];
          const c = a.match(/(\d+(\.\d+)?)/g)[0];
          const d = a.match(/(\d+(\.\d+)?)/g)[1];
          // 提取匹配结果
          // const b = matches[1] || ''; // 东经（或空字符串）
          // const c = matches[2] || ''; // 12（或空字符串）
          // const d = matches[3] || '';

          this.$set(this.yt.editObj, 'longitude', b);
          this.$set(this.yt.editObj, 'longitudeNum', c);
          this.$set(this.yt.editObj, 'longitudeDivide', d);
        }
        if (this.yt.editObj.latitude !== '') {
          let a = this.yt.editObj.latitude;
          // const regex = /(\D+)?(\d+)?度?(\d+)?分?/;
          // const matches = a.match(regex);
          // 提取 b 为 "南纬"
          const b = a.match(/([\u4e00-\u9fa5]+)/)[0];
          const c = a.match(/(\d+(\.\d+)?)/g)[0];
          const d = a.match(/(\d+(\.\d+)?)/g)[1];
          // 提取匹配结果
          // const b = matches[1] || ''; // 东经（或空字符串）
          // const c = matches[2] || ''; // 12（或空字符串）
          // const d = matches[3] || '';
          this.$set(this.yt.editObj, 'latitude', b);
          this.$set(this.yt.editObj, 'latitudeNum', c);
          this.$set(this.yt.editObj, 'latitudeDivide', d);
        }
      }

      console.log('this.yt.editObj', this.yt.editObj);
      return this.yt.editObj;
    },
    choose(value) {
      this.chooseSelf = value;
    },
    /**
     * 设置配置点看板 右侧数据点击排序
     */
    changePoint(type, value) {
      let valueIndex = null;
      for (let i = 0; i < this.settingPoint.length; i++) {
        if (this.settingPoint[i] === value) {
          valueIndex = i;
        }
      }
      if (type === 'up' && valueIndex !== 0) {
        const beforeValue = this.settingPoint[valueIndex - 1]; // 上一个值
        this.settingPoint.splice(valueIndex, 1, beforeValue);
        this.settingPoint.splice(valueIndex - 1, 1, value);
      }
      if (type === 'down' && valueIndex !== this.settingPoint.length - 1) {
        const afterValue = this.settingPoint[valueIndex + 1]; // 下一个值
        this.settingPoint.splice(valueIndex, 1, afterValue);
        this.settingPoint.splice(valueIndex + 1, 1, value);
      }
    },
    /**
     * 批量设置看板配置点 右侧数据点击排序
     */
    changeSort(type, value) {
      let valueIndex = null;
      for (let i = 0; i < this.settingBatchPoint.length; i++) {
        if (this.settingBatchPoint[i] === value) {
          valueIndex = i;
        }
      }
      if (type === 'up' && valueIndex !== 0) {
        const beforeValue = this.settingBatchPoint[valueIndex - 1]; // 上一个值
        this.settingBatchPoint.splice(valueIndex, 1, beforeValue);
        this.settingBatchPoint.splice(valueIndex - 1, 1, value);
      }
      if (type === 'down' && valueIndex !== this.settingBatchPoint.length - 1) {
        const afterValue = this.settingBatchPoint[valueIndex + 1]; // 下一个值
        this.settingBatchPoint.splice(valueIndex, 1, afterValue);
        this.settingBatchPoint.splice(valueIndex + 1, 1, value);
      }
      this.settingBatchPoints = this.settingBatchPoint;
    },
    exportExcel() {
      let params = this.yt.conditions;
      return this.http
        .get('/web/report/export/equipment_standing_book_export', {
          params
        })
        .then(res => {
          this.$message.success(this.$t(res.msg));
          this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    // 保存批量设置看板配置点
    setBatchEquipmentBoard() {
      let showJson = [...this.settingBatchData];
      for (let i = 0; i < showJson.length; i++) {
        showJson[i]['selected'] = this.settingBatchPoint.includes(showJson[i]['code']);
      }
      for (let i = 0; i < this.settingBatchPoint.length; i++) {
        for (let j = 0; j < showJson.length; j++) {
          if (this.settingBatchPoint[i] === showJson[j]['code']) {
            showJson[j]['sort'] = i + 1;
          }
        }
      }
      showJson = showJson.sort(function (a, b) {
        return a.sort - b.sort;
      });
      // console.log('this.settingBatchPoint', this.settingBatchPoint)
      // console.log('showJson', showJson)
      let requestParam = {
        equipmentIdList: this.selectEquipment,
        showJson: JSON.stringify(
          showJson.map(item => {
            return {
              code: item.code,
              desc: item.desc,
              i18n: item.i18n,
              selected: item.selected
            };
          })
        )
      };
      return this.http
        .post('/web/monitor/setBatchEquipmentBoard', requestParam)
        .then(response => {
          this.$message.success(this.$t(response.msg));
          this.yt.isShowEditDialog = false;
        })
        .catch(error => {
          this.$message.error(error);
        });
    },
    // 批量设置看板配置点
    getBatchEquipmentBoard() {
      return this.http
        .get('/web/monitor/getBatchEquipmentBoard')
        .then(response => {
          if (response.data) {
            response.data.forEach(e => {
              e.desc = this.$t(e.i18n);
            });
          }
          if (response.data.length > 0) {
            this.settingBatchPoint = response.data
              .filter(item => {
                return item.selected === true;
              })
              .map(item => {
                return item.code;
              });
          }
          this.settingBatchData = response.data || [];
          for (let i = 0; i < this.settingBatchData.length; i++) {
            this.settingBatchData[i]['sort'] = 1000;
          }
          // this.$message.success(this.$t(response.msg))
        })
        .catch(error => {
          this.$message.error(error);
        });
    },
    // 获取设备列表
    getEquipmentList() {
      return this.http
        .get(
          '/web/equipment/standing_book/page?' +
          this.qs.stringify({
            pageNum: 1,
            pageSize: 999,
            orderBy: 'sort'
          })
        )
        .then(response => {
          for (var i = 0; i < response.data.rows.length; i++) {
            if (response.data.rows[i]['name'] == null || response.data.rows[i]['name'] == "") {
              response.data.rows[i]['name'] = ' ';
            }
          }
          this.equipmentList = response.data.rows || [];
        });
    },
    // 保存设置看板配置点
    setEquipmentBoard() {
      let showJson = [...this.settingData];
      for (let i = 0; i < showJson.length; i++) {
        showJson[i]['selected'] = this.settingPoint.includes(showJson[i]['code']);
      }
      for (let i = 0; i < this.settingPoint.length; i++) {
        for (let j = 0; j < showJson.length; j++) {
          if (this.settingPoint[i] === showJson[j]['code']) {
            showJson[j]['sort'] = i + 1;
          }
        }
      }
      showJson = showJson.sort(function (a, b) {
        return a.sort - b.sort;
      });
      // console.log('showJson', showJson)
      let requestParam = {
        equipmentId: this.yt.editObj.id,
        showJson: JSON.stringify(
          showJson.map(item => {
            return {
              code: item.code,
              desc: item.desc,
              i18n: item.i18n,
              selected: item.selected
            };
          })
        )
      };
      return this.http
        .post('/web/monitor/setEquipmentBoard', requestParam)
        .then(response => {
          this.$message.success(this.$t(response.msg));
          this.yt.isShowEditDialog = false;
        })
        .catch(error => {
          this.$message.error(error);
        });
    },
    // 设置看板配置点
    getEquipmentBoard() {
      return this.http
        .get(
          '/web/monitor/getEquipmentBoard?' +
          this.qs.stringify({
            equipmentId: this.yt.editObj.id
          })
        )
        .then(response => {
          if (response.data) {
            response.data.forEach(e => {
              e.desc = this.$t(e.i18n);
            });
          }
          if (response.data.length > 0) {
            this.settingPoint = response.data
              .filter(item => {
                return item.selected === true;
              })
              .map(item => {
                return item.code;
              });
          }
          this.settingData = response.data || [];
          for (let i = 0; i < this.settingData.length; i++) {
            this.settingData[i]['sort'] = 1000;
          }
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    // async getOrganizationList() {
    // 	let response = await this.http.get('/web/setting/org/page', {
    // 		params: {
    // 			pageNum: 1,
    // 			pageSize: 10
    // 		}
    // 	})
    // 	this.organizationList = response.data.rows
    // },
    submitEquipmentStanding() {
      let data = this.$refs.equipmentStanding.$refs.yt.list;
      let sns = data.map(item => {
        return item.sn;
      });

      this.http
        .post('web/equipment/standing_book/equipmentOrgUpdate', {
          sns
        })
        .then(res => {
          this.yt.isShowEditDialog = false;
          this.yt.get(1);
        });
    },
    // 选中设备
    handleSelectionChange(section, value) {
      let res = this.multipleSelection.filter(item => {
        return item.id == value.id;
      });
      if (res.length > 0) {
        this.multipleSelection = this.multipleSelection.filter(item => {
          return item.id != value.id;
        });
      } else {
        this.multipleSelection.push(value);
      }
    },
    // 关闭tag标签
    closeTag(id) {
      this.multipleSelection = this.multipleSelection.filter(item => {
        return item.id != id;
      });
      let ids = this.multipleSelection.map(item => {
        return item.id;
      });
      this.$nextTick(() => {
        this.tableData.forEach(row => {
          if (ids.indexOf(row.id) == -1) {
            this.$refs.table.toggleRowSelection(row, false);
          }
        });
      });
    },
    // 监听分页
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getStandingBook();
    },
    // 搜索
    searchStandingBook() {
      this.pageNum = 1;
      this.getStandingBook();
    },
    // 重置
    reset() {
      this.pageNum = 1;
      this.queryParam = {};
      this.getStandingBook();
    },
    // 获取设备列表
    async getStandingBook() {
      let param = Object.assign(
        {
          pageNum: this.pageNum,
          pageSize: this.pageSize
        },
        this.queryParam
      );
      let response = await this.http.get('/web/equipment/standing_book/page', {
        params: param
      });
      if (response.code == 200) {
        this.total = response.data.total;
        this.tableData = response.data.rows;
        this.$nextTick(() => {
          this.tableData.forEach(row => {
            let ids = this.multipleSelection.map(item => {
              return item.id;
            });
            if (ids.indexOf(row.id) >= 0) {
              this.$refs.table.toggleRowSelection(row, true);
            }
          });
        });
      }
    },
    // 确认调拨
    submitAllocation() {
      return this.http
        .post('/web/equipment/standing_book/equipmentOrgUpdate', {
          equipmentIds: this.yt.editObj.equipmentIds,
          orgId: this.simpleOrgId
        })
        .then(response => {
          this.$message.success(this.$t(response.msg));
          this.yt.isShowEditDialog = false;
          this.yt.get(1);
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    // 加载组织关系图
    async setGraphData() {
      let response = await this.http.get('/web/setting/org/tree');
      let data = {};
      if (response.code == 200 && response.data.length > 0) {
        data = [response.data[0]];
      }
      let __graph_json_data = {
        nodes: data,
        links: []
      };
      setTimeout(
        function () {
          this.g_loading = false;
          this.$refs.seeksRelationGraph.setJsonData(__graph_json_data, seeksRGGraph => { });
        }.bind(this),
        1000
      );
    },
    // 点击组织
    onNodeClick(nodeObject, $event) {
      this.selectOrg = nodeObject;
    },
    // 取消组织
    cancelNode() {
      this.orgId = '';
      this.selectOrg = {
        text: ''
      };
      this.orgDialog = false;
    },
    // 确认组织
    submitOrg() {
      this.orgId = this.selectOrg.id;
      this.orgDialog = false;
    },
    chooseAll() {
      this.printSN = this.$store.state.eqs.map(item => { return item.sn; });
    },
    preview() {
      this.isShowPrint = true;
      console.log(this.printSN);
    },
    getDpi(num) {
      const inch = document.createElement('div');
      inch.style.width = '1in';
      document.body.appendChild(inch);
      const dpi = inch.offsetWidth;
      document.body.removeChild(inch);
      const unit = Number(num);
      const inchs = unit / 25.4;
      const px = inchs * dpi;
      return Math.round(px);
    },
    print() {
      for (let index = 0; index < this.printSN.length; index++) {
        this.domToPdfBase64('printContent_' + index);
      }
    },
    domToPdfBase64(targetId) {
      var targetDom = document.getElementById(targetId); //你的目标元素id
      var copyDom = targetDom.cloneNode(true); // 克隆节点
      copyDom.style.width = targetDom.offsetWidth + 'px';
      copyDom.style.height = targetDom.scrollHeight + 'PX'; // 获得高度
      document.body.appendChild(copyDom); // 插入节点
      html2canvas(copyDom).then(canvas => {
        document.body.removeChild(copyDom); // 删除节点
        var contentWidth = canvas.width;
        var contentHeight = canvas.height;
        var imgWidth = contentWidth;
        var imgHeight = contentHeight;
        var pageData = canvas.toDataURL('image/jpeg', 1.0);
        //第一个参数： l：横向  p：纵向;第二个参数：测量单位（"pt"，"mm", "cm", "m", "in" or "px"）;第三个参数：可以是下面格式，默认为“a4”
        var pdf = new jsPDF('l', 'px', [imgWidth, imgHeight]);
        pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
        let pdf64 = pdf.output('blob');
        this.blobs.push(pdf64);
        if (this.blobs.length == this.printSN.length) {
          this.sends();
        }
      });
    },
    sends() {
      const formData = new FormData();
      for (let index = 0; index < this.blobs.length; index++) {
        formData.append('files[]', this.blobs[index]);
        formData.append('isVertical', 'true');//不需要旋转图片
      }
      this.printLoading = true;
      this.http.post('http://127.0.0.1:9090/printLocalPDF', formData, {
        headers: {
          'Content-Type': 'multipart/form-data' // 设置请求头，确保服务器正确解析 FormData
        }
      }).then(res => {
        console.log(res);
      }).finally(() => {
        this.printLoading = false;
        this.$message.success(this.$t('chenggong'));
        this.isShowPrint = false;
        this.yt.isShowEditDialog = false;
        this.printSN = [];
      });
      this.blobs = [];
    },
  }
};
</script>
